import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";

import Attachment from "../subparts/globals/attachment";
import {DECORS_MAX} from "../constants";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";

const compareMountPosition = (checkFeature, dbFeatureLoading) => {
  return checkFeature.metaData["MatchingFeature"] && checkFeature.matchesMetaForCondition("MatchingFeature", dbFeatureLoading.metaData["MatchingFeature"])
}

const checkForExistingDecor = (currentDecorFeatureGroup, dbFeature) => {
  if (!currentDecorFeatureGroup) { // we skipped all decors, but didn't find the same
    return true
  }
  if (dbFeature.sharedFeatureName === currentDecorFeatureGroup.decorName) { // decors are matching by name
    return true
  }
  if (dbFeature.metaData["MountPosition"]) {
    if (Array.isArray(dbFeature.metaData["RoomLayout"])) {
      return dbFeature.metaData["RoomLayout"].some(layoutName => {
        return currentDecorFeatureGroup.featuresList && Array.isArray(currentDecorFeatureGroup.featuresList[layoutName])
          && currentDecorFeatureGroup.featuresList[layoutName].some(feature => compareMountPosition(feature, dbFeature))
      })
    } else {
      return currentDecorFeatureGroup.some(feature => compareMountPosition(feature, dbFeature))
    }
  }
  return false
}

export default class Accessories extends Part {
  static id = "Accessories";
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Accessories';
    this.partThumbnail = "";
    this.translateId = "visualizer.bathroom.accessories2";

    // related items
    this.attachment1 = null; // can be up to 10
  }

  load(dbFeature) {
    let
      relatedItemName = "",
      decorCount = 0,
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Attachment": {
        for (let i = 1; i <= DECORS_MAX; i++) {
          const currentDecorFeatureGroup = this["attachment" + i];
          if (checkForExistingDecor(currentDecorFeatureGroup, dbFeature)) {
            relatedItemName = "attachment" + i;
            decorCount = i;
            break;
          }
        }
        break;
      }
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        if (dbFeature.groupName === "Attachment") {
          this[relatedItemName] = new Attachment(true, decorCount);
          this[relatedItemName].decorName = dbFeature.sharedFeatureName;
        } else {
          this[relatedItemName] = new RelatedItemClass(true);
        }
        this.relatedItems.push(this[relatedItemName]);
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  navigationItem() {
    return new DesignNavigationItem('Accessories', this);
  }

}
